import { Vocabulary } from 'sdk/services/vocabulary/types/vocabulary'

export const profileType = {
  PROFILE: 'profile-info-button',
  LEGAL: 'legal-button',
  LOGOUT: 'logout-button',
}

export const MAX_PROFILES_NUMBER = 5

export const contentClassificationArray = (V: Vocabulary) => [
  { ageRating: '+0', label: V.contentClassificationAge_0_TV },
  { ageRating: '+3', label: V.contentClassificationAge_3_TV },
  { ageRating: '+7', label: V.contentClassificationAge_7_TV },
  { ageRating: '+12', label: V.contentClassificationAge_12_TV },
  { ageRating: '+16', label: V.contentClassificationAge_16_TV },
]

export const storageProfileIdentifier = 'identifier'
